var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "a",
        "data-name": "Ebene 1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 196 145.88"
      }
    },
    [
      _c("defs", [
        _c("clipPath", { attrs: { id: "c" } }, [
          _c("rect", {
            staticClass: "e",
            attrs: { width: "196", height: "145.88" }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "d" } }, [
          _c("rect", {
            staticClass: "e",
            attrs: { width: "196", height: "145.88" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "b", "data-name": "Bildmaterial 1" } }, [
        _c("g", { staticClass: "j" }, [
          _c("g", { staticClass: "i" }, [
            _c("path", {
              staticClass: "h",
              attrs: {
                d:
                  "M4.81,10.77c4.09,2.19,60.72,32.62,62.83,33.75,4.82,2.22,10.36,2.22,15.18,0,2.11-1.13,58.74-31.56,62.83-33.75C149.73,8.58,153.61,0,146.1,0H4.36C-3.15,0,.72,8.57,4.81,10.77M147.54,29.23c-4.65,2.42-61.88,32.24-64.73,33.73-2.33,1.25-4.95,1.82-7.59,1.67-2.64,.16-5.26-.42-7.59-1.67-2.85-1.49-59.75-31.32-64.4-33.74-3.27-1.71-3.23,.29-3.23,1.83v61.09c0,3.52,4.74,8.38,8.38,8.38H142.41c3.64,0,8.38-4.86,8.38-8.38V31.06c0-1.54,.03-3.54-3.24-1.83"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "g",
              attrs: {
                d:
                  "M151,55.88c24.85,0,45,20.15,45,45s-20.15,45-45,45-45-20.15-45-45,20.15-45,45-45"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "f",
              attrs: {
                d:
                  "M133.62,77.95c1.01,0,5.62,.29,11.59,.29,7.78-.07,10.8-.14,13.32-.14,7.42,0,12.31,4.18,12.31,10.3s-4.61,10.08-10.51,12.02c-.21,.07-.29,.36-.21,.58,1.29,3.24,5.11,10.22,7.99,14.11,1.8,2.45,3.1,3.1,7.2,3.53,.14,.65-.22,3.1-.72,3.46-3.96,.36-12.31,.14-14.26-1.01-1.87-1.08-3.02-2.95-3.38-3.74-2.16-3.74-4.25-8.21-6.26-12.74-.43-.86-1.22-1.58-1.66-1.66-.43-.07-1.22-.15-1.58-.15-.14,0-.5,.43-.5,.58-.79,4.39-1.15,7.27-1.73,11.38-.22,1.58,.36,2.74,1.58,3.1,1.58,.58,2.88,.65,4.61,.94,.36,.58-.22,2.81-.72,3.38-2.16,0-5.11-.29-11.66-.29-7.63,0-11.16,.22-12.1,.29-.14-.79-.07-2.74,.36-3.38,1.01-.14,3.67-.5,4.61-.79,1.66-.29,2.3-1.37,2.66-3.31,1.51-7.13,4.46-25.99,4.82-29.59,.22-1.58-.43-2.45-1.58-2.74-.94-.29-3.02-.72-4.61-.94-.22-.5,.22-3.24,.43-3.46m18.94,4.18c-.29,0-1.37,0-1.73,.14-.29,.14-.58,.43-.65,.72-.94,5.26-1.8,10.3-2.59,15.77-.07,.36,.22,.58,.43,.58,4.03,0,6.26-.86,7.42-1.37,2.52-1.22,4.61-3.46,4.61-7.99s-2.88-7.85-7.49-7.85"
              }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }